import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { Card } from './ui/Card';
import { useTranslation } from '../i18n';
export function GoogleReviews() {
  const {
    t
  } = useTranslation();
  const reviews = [{
    name: t('reviews.review1.name'),
    text: t('reviews.review1.text'),
    date: t('reviews.review1.date')
  }, {
    name: t('reviews.review2.name'),
    text: t('reviews.review2.text'),
    date: t('reviews.review2.date')
  }, {
    name: t('reviews.review3.name'),
    text: t('reviews.review3.text'),
    date: t('reviews.review3.date')
  }];
  return <section className="py-16 bg-gray-50" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="text-center mb-12" data-id="element-66">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-67">
            <div className="flex gap-1" data-id="element-68">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-yellow-400 fill-current" data-id="element-69" />)}
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-70">
            {t('reviews.title')}
          </h2>
          <p className="text-lg text-gray-600 font-medium" data-id="element-71">
            {t('reviews.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-72">
          {reviews.map((review, idx) => <Card key={idx} className="p-6 h-full flex flex-col" data-id="element-73">
              <div className="flex items-center gap-1 mb-4" data-id="element-74">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-75" />)}
              </div>
              <p className="text-gray-700 mb-6 flex-grow italic" data-id="element-76">
                "{review.text}"
              </p>
              <div className="flex justify-between items-end mt-auto pt-4 border-t border-gray-100" data-id="element-77">
                <span className="font-semibold text-gray-900" data-id="element-78">
                  {review.name}
                </span>
                <span className="text-sm text-gray-400" data-id="element-79">{review.date}</span>
              </div>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-80">
          <a href="https://maps.app.goo.gl/883P9mBhZq6qZuSN6" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-teal-600 font-medium hover:text-teal-700 transition-colors" data-id="element-81">
            <MapPin className="w-5 h-5" data-id="element-82" />
            {t('reviews.viewAll')}
          </a>
        </div>
      </div>
    </section>;
}